import { TLanguage } from '@lifk/types'
import { useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { ComputedRef, computed, watch } from 'vue'

export type TLanguageAbbr = 'en' | 'es'

interface ILanguage {
  name: TLanguage
  map: TLanguageAbbr
}

export const languages: ILanguage[] = [
  {
    name: 'en-us',
    map: 'en'
  },
  {
    name: 'es-mx',
    map: 'es'
  }
]

export const useLanguageStore = defineStore('language', () => {
  const language = useStorage<TLanguage>('language', languages[0].name)

  watch(
    language,
    () => {
      // For backwards compatibility if users have old languages in localStorage
      if ((language.value as string) === 'english') {
        language.value = 'en-us'
      } else if ((language.value as string) === 'spanish') {
        language.value = 'es-mx'
      }
    },
    {
      immediate: true
    }
  )

  const currentMapLanguage: ComputedRef<TLanguageAbbr> = computed(() => {
    let currentLanguageObject = languages.find((l) => l.name === language.value)
    if (!currentLanguageObject) {
      console.error('Language not found: ', language.value)
      currentLanguageObject = languages[0] // default to english
    }
    return currentLanguageObject.map
  })

  watch(
    currentMapLanguage,
    (newVal) => {
      document.documentElement.setAttribute('lang', newVal)
    },
    { immediate: true }
  )

  return { language, currentMapLanguage }
})
